import React from "react";
import { Col, Row } from "react-bootstrap";

const EarningFeature = ({ data }) => {
  return (
    <>
      <Row className="row-cols-lg-5 row-cols-md-4 row-cols-sm-3">
        <Col className="my-2">
          <div className="cardCstm m-0 bg-white rounded p-2 py-3 border d-flex align-items-start position-relative">
            <span
              className="icn position-absolute"
              style={{ top: 5, right: 5 }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 22 22"
                fill="none"
              >
                <rect
                  x="21.8438"
                  y="21.896"
                  width="21.4808"
                  height="21.4808"
                  rx="10.7404"
                  transform="rotate(-180 21.8438 21.896)"
                  fill="#467912"
                />
                <g clip-path="url(#clip0_0_2329)">
                  <path
                    d="M8.9095 10.5608C9.02569 10.677 9.18327 10.7422 9.34758 10.7422C9.51189 10.7422 9.66947 10.677 9.78567 10.5608L10.8967 9.4498L10.8967 13.5308C10.8967 13.6951 10.962 13.8527 11.0782 13.9689C11.1944 14.0851 11.352 14.1504 11.5163 14.1504C11.6807 14.1504 11.8383 14.0851 11.9545 13.9689C12.0707 13.8527 12.136 13.6951 12.136 13.5308L12.136 9.4498L13.247 10.5608C13.3638 10.6737 13.5204 10.7361 13.6828 10.7347C13.8453 10.7333 14.0007 10.6682 14.1156 10.5533C14.2305 10.4384 14.2956 10.283 14.2971 10.1205C14.2985 9.95804 14.236 9.80151 14.1231 9.68465L11.9544 7.51591C11.8382 7.39975 11.6806 7.33449 11.5163 7.33449C11.352 7.33449 11.1944 7.39975 11.0782 7.51591L8.9095 9.68465C8.79333 9.80085 8.72807 9.95843 8.72807 10.1227C8.72807 10.287 8.79333 10.4446 8.9095 10.5608Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_0_2329">
                    <rect
                      width="7.43568"
                      height="7.43567"
                      fill="white"
                      transform="translate(15.2343 14.4602) rotate(-180)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <div className="imgWrp me-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="35"
                height="35"
                viewBox="0 0 42 42"
                fill="none"
              >
                <circle cx="21.1669" cy="21.0006" r="20.2173" fill="#D9D9D9" />
                <g clip-path="url(#clip0_66_238)">
                  <path
                    d="M23.9466 17.4136C21.1446 17.4136 18.8654 19.693 18.8654 22.4948C18.8654 25.2966 21.1446 27.5761 23.9466 27.5761C26.7486 27.5761 29.0279 25.2967 29.0279 22.4949C29.0279 19.6931 26.7486 17.4136 23.9466 17.4136ZM24.2427 22.0819C24.7899 22.4739 25.471 22.9618 25.471 23.7652C25.471 24.4267 25.0449 24.9855 24.4547 25.1959V25.5436C24.4547 25.8243 24.2271 26.0518 23.9466 26.0518C23.6661 26.0518 23.4384 25.8243 23.4384 25.5436V25.1959C22.8483 24.9855 22.4222 24.4267 22.4222 23.7652C22.4222 23.4845 22.6498 23.257 22.9303 23.257C23.2109 23.257 23.4385 23.4845 23.4385 23.7652C23.4385 24.0453 23.6664 24.2733 23.9466 24.2733C24.2268 24.2733 24.4548 24.0454 24.4548 23.7652C24.4548 23.484 24.0459 23.1911 23.6506 22.9079C23.1034 22.5159 22.4223 22.0279 22.4223 21.2246C22.4223 20.563 22.8483 20.0042 23.4385 19.7938V19.4461C23.4385 19.1654 23.6661 18.938 23.9466 18.938C24.2272 18.938 24.4548 19.1654 24.4548 19.4461V19.7938C25.045 20.0043 25.471 20.563 25.471 21.2246C25.471 21.5053 25.2434 21.7327 24.9629 21.7327C24.6824 21.7327 24.4548 21.5053 24.4548 21.2246C24.4548 20.9444 24.2268 20.7164 23.9466 20.7164C23.6665 20.7164 23.4385 20.9444 23.4385 21.2246C23.4385 21.5057 23.8473 21.7987 24.2427 22.0819Z"
                    fill="#534F4F"
                  />
                  <path
                    d="M18.0181 17.4135C20.1696 17.4135 21.9138 16.5793 21.9138 15.5504C21.9138 14.5214 20.1696 13.6872 18.0181 13.6872C15.8666 13.6872 14.1225 14.5214 14.1225 15.5504C14.1225 16.5793 15.8666 17.4135 18.0181 17.4135Z"
                    fill="#534F4F"
                  />
                  <path
                    d="M18.0181 18.43C17.026 18.43 15.6456 18.259 14.798 17.8771C14.5473 17.7697 14.3216 17.6478 14.1225 17.5136V18.9381C14.1225 19.3037 14.538 19.7088 15.2069 19.9954C15.811 20.2676 16.9897 20.4625 18.0181 20.4625C18.0827 20.4625 18.1438 20.4552 18.2078 20.4537C18.4982 19.64 18.9542 18.906 19.539 18.2929C19.0619 18.3826 18.5508 18.43 18.0181 18.43Z"
                    fill="#534F4F"
                  />
                  <path
                    d="M18.2029 24.523C18.1412 24.5243 18.0803 24.5275 18.0182 24.5275C17.0261 24.5275 15.6456 24.3565 14.798 23.9746C14.5426 23.8653 14.295 23.7274 14.1225 23.6112V25.0357C14.1225 25.6495 15.7584 26.5601 18.0181 26.5601C18.466 26.5601 18.9035 26.5207 19.3115 26.4468C18.8312 25.8844 18.4547 25.2336 18.2029 24.523Z"
                    fill="#534F4F"
                  />
                  <path
                    d="M17.9408 21.4769C16.9551 21.4686 15.6245 21.298 14.798 20.9256C14.5426 20.8163 14.295 20.6784 14.1225 20.5622V21.9867C14.1225 22.3522 14.538 22.7573 15.2069 23.0439C15.7959 23.3095 16.9305 23.4999 17.9403 23.5093C17.8846 23.1786 17.8488 22.8411 17.8488 22.4948C17.8488 22.1473 17.8847 21.8087 17.9408 21.4769Z"
                    fill="#534F4F"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_66_238">
                    <rect
                      width="14.9051"
                      height="14.9051"
                      fill="white"
                      transform="translate(14.1223 13.1795)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div className="content">
              <h4 className="m-0 fw-bold" style={{ color: "#E97B7B" }}>
                {data?.totalEarning?.toString() || "-"}
              </h4>
              <p className="m-0 fw-sbold" style={{ fontSize: 10 }}>
                Total Earned Amount
              </p>
            </div>
          </div>
        </Col>
        <Col className="my-2">
          <div className="cardCstm m-0 bg-white rounded p-2 py-3 border d-flex align-items-start position-relative">
            <span
              className="icn position-absolute"
              style={{ top: 5, right: 5 }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 22 22"
                fill="none"
              >
                <rect
                  x="21.8438"
                  y="21.896"
                  width="21.4808"
                  height="21.4808"
                  rx="10.7404"
                  transform="rotate(-180 21.8438 21.896)"
                  fill="#467912"
                />
                <g clip-path="url(#clip0_0_2329)">
                  <path
                    d="M8.9095 10.5608C9.02569 10.677 9.18327 10.7422 9.34758 10.7422C9.51189 10.7422 9.66947 10.677 9.78567 10.5608L10.8967 9.4498L10.8967 13.5308C10.8967 13.6951 10.962 13.8527 11.0782 13.9689C11.1944 14.0851 11.352 14.1504 11.5163 14.1504C11.6807 14.1504 11.8383 14.0851 11.9545 13.9689C12.0707 13.8527 12.136 13.6951 12.136 13.5308L12.136 9.4498L13.247 10.5608C13.3638 10.6737 13.5204 10.7361 13.6828 10.7347C13.8453 10.7333 14.0007 10.6682 14.1156 10.5533C14.2305 10.4384 14.2956 10.283 14.2971 10.1205C14.2985 9.95804 14.236 9.80151 14.1231 9.68465L11.9544 7.51591C11.8382 7.39975 11.6806 7.33449 11.5163 7.33449C11.352 7.33449 11.1944 7.39975 11.0782 7.51591L8.9095 9.68465C8.79333 9.80085 8.72807 9.95843 8.72807 10.1227C8.72807 10.287 8.79333 10.4446 8.9095 10.5608Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_0_2329">
                    <rect
                      width="7.43568"
                      height="7.43567"
                      fill="white"
                      transform="translate(15.2343 14.4602) rotate(-180)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <div className="imgWrp me-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="35"
                height="35"
                viewBox="0 0 42 42"
                fill="none"
              >
                <circle cx="21.1828" cy="21.0006" r="20.2173" fill="#D9D9D9" />
                <g clip-path="url(#clip0_66_240)">
                  <path
                    d="M29.0945 18.4133C29.035 18.2183 28.9006 18.0547 28.7208 17.9584C28.5411 17.8622 28.3305 17.841 28.1351 17.8996C27.9398 17.9582 27.7756 18.0918 27.6785 18.2712C27.5815 18.4505 27.5594 18.661 27.6171 18.8566C27.7946 19.4499 27.8845 20.0658 27.8839 20.6851C27.8839 24.1892 25.0332 27.04 21.529 27.04C18.0249 27.04 15.1741 24.1892 15.1741 20.6851C15.1741 17.1809 18.0249 14.3301 21.529 14.3301C22.7677 14.3279 23.9798 14.6894 25.015 15.3698C25.0996 15.4269 25.1947 15.4666 25.2948 15.4867C25.3948 15.5068 25.4979 15.5068 25.598 15.4867C25.6981 15.4667 25.7932 15.4269 25.8778 15.3699C25.9624 15.3128 26.0349 15.2394 26.091 15.1541C26.147 15.0688 26.1856 14.9732 26.2044 14.8729C26.2233 14.7726 26.222 14.6695 26.2007 14.5697C26.1794 14.4699 26.1386 14.3752 26.0804 14.2913C26.0223 14.2074 25.9481 14.1359 25.8621 14.0809C24.2276 13.0077 22.2532 12.5791 20.3209 12.8778C18.3886 13.1766 16.6359 14.1815 15.4018 15.6982C14.1678 17.2148 13.5403 19.1353 13.6407 21.088C13.7411 23.0407 14.5623 24.8867 15.9453 26.2687C17.1896 27.5106 18.8124 28.3019 20.5571 28.5175C22.3017 28.7332 24.0684 28.3607 25.5775 27.4591C27.0866 26.5576 28.2519 25.1784 28.8889 23.54C29.5259 21.9016 29.5983 20.0975 29.0945 18.4133Z"
                    fill="#534F4F"
                  />
                  <path
                    d="M25.1178 17.9799L20.3725 22.7264L17.9404 20.2942C17.8688 20.2226 17.7837 20.1658 17.6902 20.127C17.5966 20.0882 17.4963 20.0683 17.395 20.0683C17.2937 20.0683 17.1934 20.0882 17.0998 20.127C17.0062 20.1658 16.9212 20.2226 16.8496 20.2942C16.7779 20.3658 16.7211 20.4509 16.6824 20.5445C16.6436 20.638 16.6237 20.7383 16.6237 20.8396C16.6237 20.9409 16.6436 21.0412 16.6824 21.1348C16.7211 21.2284 16.7779 21.3134 16.8496 21.385L19.6047 24.1399C19.8084 24.3435 20.0845 24.4579 20.3725 24.4579C20.6605 24.4579 20.9367 24.3435 21.1404 24.1399L26.2086 19.0707C26.3532 18.9261 26.4345 18.7299 26.4345 18.5253C26.4345 18.3208 26.3532 18.1246 26.2086 17.9799C26.0639 17.8353 25.8677 17.754 25.6632 17.754C25.4586 17.754 25.2624 17.8353 25.1178 17.9799Z"
                    fill="#534F4F"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_66_240">
                    <rect
                      width="15.7947"
                      height="15.7947"
                      fill="white"
                      transform="translate(13.6018 12.7875)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div className="content">
              <h4 className="m-0 fw-bold" style={{ color: "#E97B7B" }}>
                {data?.totalConfirmedBookings?.toString() || "-"}
              </h4>
              <p className="m-0 fw-sbold" style={{ fontSize: 10 }}>
                Accepted Bookings
              </p>
            </div>
          </div>
        </Col>
        <Col className="my-2">
          <div className="cardCstm m-0 bg-white rounded p-2 py-3 border d-flex align-items-start position-relative">
            <span
              className="icn position-absolute"
              style={{ top: 5, right: 5 }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 22 22"
                fill="none"
              >
                <rect
                  x="21.8438"
                  y="21.896"
                  width="21.4808"
                  height="21.4808"
                  rx="10.7404"
                  transform="rotate(-180 21.8438 21.896)"
                  fill="#467912"
                />
                <g clip-path="url(#clip0_0_2329)">
                  <path
                    d="M8.9095 10.5608C9.02569 10.677 9.18327 10.7422 9.34758 10.7422C9.51189 10.7422 9.66947 10.677 9.78567 10.5608L10.8967 9.4498L10.8967 13.5308C10.8967 13.6951 10.962 13.8527 11.0782 13.9689C11.1944 14.0851 11.352 14.1504 11.5163 14.1504C11.6807 14.1504 11.8383 14.0851 11.9545 13.9689C12.0707 13.8527 12.136 13.6951 12.136 13.5308L12.136 9.4498L13.247 10.5608C13.3638 10.6737 13.5204 10.7361 13.6828 10.7347C13.8453 10.7333 14.0007 10.6682 14.1156 10.5533C14.2305 10.4384 14.2956 10.283 14.2971 10.1205C14.2985 9.95804 14.236 9.80151 14.1231 9.68465L11.9544 7.51591C11.8382 7.39975 11.6806 7.33449 11.5163 7.33449C11.352 7.33449 11.1944 7.39975 11.0782 7.51591L8.9095 9.68465C8.79333 9.80085 8.72807 9.95843 8.72807 10.1227C8.72807 10.287 8.79333 10.4446 8.9095 10.5608Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_0_2329">
                    <rect
                      width="7.43568"
                      height="7.43567"
                      fill="white"
                      transform="translate(15.2343 14.4602) rotate(-180)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <div className="imgWrp me-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="35"
                height="35"
                viewBox="0 0 42 42"
                fill="none"
              >
                <circle cx="21.1988" cy="21.0006" r="20.2173" fill="#D9D9D9" />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M26.0001 27.8115C27.8288 27.1513 29.0436 25.4113 29.0331 23.4671C29.031 22.4806 28.7087 21.5213 28.1146 20.7337C28.1405 20.668 28.1554 20.5984 28.1587 20.5279L28.1146 15.2226C28.0905 14.0729 27.1408 13.1593 25.991 13.1798H16.2769C15.1271 13.1593 14.1774 14.0729 14.1533 15.2226V24.3636C14.1774 25.5133 15.1271 26.4269 16.2769 26.4064H20.7666C20.8081 26.4099 20.8499 26.4099 20.8915 26.4064C22.1253 27.9088 24.1715 28.4716 26.0001 27.8115ZM25.1754 16.8539C25.1754 16.4481 24.8464 16.1191 24.4406 16.1191H17.8273C17.4215 16.1191 17.0925 16.4481 17.0925 16.8539C17.0925 17.2597 17.4215 17.5887 17.8273 17.5887H24.4406C24.8464 17.5887 25.1754 17.2597 25.1754 16.8539ZM26.4319 22.2106C26.571 22.3486 26.6493 22.5364 26.6493 22.7323C26.6493 22.9283 26.571 23.1161 26.4319 23.254L24.2275 25.4585C24.0888 25.596 23.9011 25.6727 23.7058 25.6716H23.5882C23.3562 25.6328 23.1568 25.4853 23.0518 25.2748L22.317 23.8051C22.175 23.5691 22.1769 23.2735 22.3219 23.0394C22.467 22.8052 22.7308 22.6718 23.0053 22.6938C23.2799 22.7159 23.5191 22.8895 23.625 23.1438L23.9042 23.7023L25.3738 22.2327C25.5093 22.0861 25.6986 22.0009 25.8982 21.9967C26.0978 21.9925 26.2905 22.0698 26.4319 22.2106ZM24.4406 18.8746C25.2137 18.8781 25.9728 19.0806 26.645 19.4624V15.2299C26.6356 15.0662 26.5613 14.9128 26.4386 14.8039C26.3158 14.695 26.1548 14.6394 25.991 14.6495H16.2769C15.9385 14.6284 15.6465 14.8844 15.6229 15.2226V24.3636C15.6465 24.7018 15.9385 24.9578 16.2769 24.9368H20.0906C19.6172 23.5352 19.8479 21.9915 20.7103 20.7897C21.5727 19.5878 22.9613 18.8749 24.4406 18.8746ZM24.4406 20.3442C26.1654 20.3442 27.5635 21.7424 27.5635 23.4671C27.5595 25.1902 26.1637 26.586 24.4406 26.5901C22.7158 26.5901 21.3177 25.1919 21.3177 23.4671C21.3177 21.7424 22.7158 20.3442 24.4406 20.3442Z"
                  fill="#534F4F"
                />
              </svg>
            </div>
            <div className="content">
              <h4 className="m-0 fw-bold" style={{ color: "#E97B7B" }}>
                {data?.totalCompletedBookings?.toString() || "-"}
              </h4>
              <p className="m-0 fw-sbold" style={{ fontSize: 10 }}>
                Completed Bookings
              </p>
            </div>
          </div>
        </Col>
        <Col className="my-2">
          <div className="cardCstm m-0 bg-white rounded p-2 py-3 border d-flex align-items-start position-relative">
            <span
              className="icn position-absolute"
              style={{ top: 5, right: 5 }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 22 22"
                fill="none"
              >
                <rect
                  x="21.8438"
                  y="21.896"
                  width="21.4808"
                  height="21.4808"
                  rx="10.7404"
                  transform="rotate(-180 21.8438 21.896)"
                  fill="#467912"
                />
                <g clip-path="url(#clip0_0_2329)">
                  <path
                    d="M8.9095 10.5608C9.02569 10.677 9.18327 10.7422 9.34758 10.7422C9.51189 10.7422 9.66947 10.677 9.78567 10.5608L10.8967 9.4498L10.8967 13.5308C10.8967 13.6951 10.962 13.8527 11.0782 13.9689C11.1944 14.0851 11.352 14.1504 11.5163 14.1504C11.6807 14.1504 11.8383 14.0851 11.9545 13.9689C12.0707 13.8527 12.136 13.6951 12.136 13.5308L12.136 9.4498L13.247 10.5608C13.3638 10.6737 13.5204 10.7361 13.6828 10.7347C13.8453 10.7333 14.0007 10.6682 14.1156 10.5533C14.2305 10.4384 14.2956 10.283 14.2971 10.1205C14.2985 9.95804 14.236 9.80151 14.1231 9.68465L11.9544 7.51591C11.8382 7.39975 11.6806 7.33449 11.5163 7.33449C11.352 7.33449 11.1944 7.39975 11.0782 7.51591L8.9095 9.68465C8.79333 9.80085 8.72807 9.95843 8.72807 10.1227C8.72807 10.287 8.79333 10.4446 8.9095 10.5608Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_0_2329">
                    <rect
                      width="7.43568"
                      height="7.43567"
                      fill="white"
                      transform="translate(15.2343 14.4602) rotate(-180)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <div className="imgWrp me-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="35"
                height="35"
                viewBox="0 0 41 41"
                fill="none"
              >
                <circle cx="20.2152" cy="20.2554" r="20.2173" fill="#D9D9D9" />
                <g clip-path="url(#clip0_66_242)">
                  <path
                    d="M13.0916 27.514C12.7262 27.5352 12.3668 27.4137 12.0892 27.1751C11.5418 26.6245 11.5418 25.7351 12.0892 25.1844L24.0756 13.1981C24.6449 12.6653 25.5383 12.6949 26.0711 13.2643C26.5528 13.7791 26.5809 14.5705 26.1368 15.1182L14.0799 27.1751C13.8059 27.4103 13.4523 27.5315 13.0916 27.514Z"
                    fill="#635D5D"
                  />
                  <path
                    d="M25.0637 27.5142C24.6934 27.5126 24.3384 27.3656 24.0755 27.1048L12.0891 15.1184C11.5819 14.5261 11.6509 13.6349 12.2431 13.1277C12.7717 12.675 13.5512 12.675 14.0798 13.1277L26.1367 25.1141C26.7059 25.647 26.7353 26.5404 26.2024 27.1096C26.1812 27.1323 26.1593 27.1542 26.1367 27.1754C25.8415 27.4321 25.4529 27.5548 25.0637 27.5142Z"
                    fill="#635D5D"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_66_242">
                    <rect
                      width="14.9051"
                      height="14.9051"
                      fill="white"
                      transform="translate(11.6792 12.7022)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div className="content">
              <h4 className="m-0 fw-bold" style={{ color: "#E97B7B" }}>
                {data?.totalCanceledBookings?.toString() || "-"}
              </h4>
              <p className="m-0 fw-sbold" style={{ fontSize: 10 }}>
                Cancel Booking
              </p>
            </div>
          </div>
        </Col>
        <Col className="my-2">
          <div className="cardCstm m-0 bg-white rounded p-2 py-3 border d-flex align-items-start position-relative">
            <span
              className="icn position-absolute"
              style={{ top: 5, right: 5 }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 22 22"
                fill="none"
              >
                <rect
                  x="21.8438"
                  y="21.896"
                  width="21.4808"
                  height="21.4808"
                  rx="10.7404"
                  transform="rotate(-180 21.8438 21.896)"
                  fill="#467912"
                />
                <g clip-path="url(#clip0_0_2329)">
                  <path
                    d="M8.9095 10.5608C9.02569 10.677 9.18327 10.7422 9.34758 10.7422C9.51189 10.7422 9.66947 10.677 9.78567 10.5608L10.8967 9.4498L10.8967 13.5308C10.8967 13.6951 10.962 13.8527 11.0782 13.9689C11.1944 14.0851 11.352 14.1504 11.5163 14.1504C11.6807 14.1504 11.8383 14.0851 11.9545 13.9689C12.0707 13.8527 12.136 13.6951 12.136 13.5308L12.136 9.4498L13.247 10.5608C13.3638 10.6737 13.5204 10.7361 13.6828 10.7347C13.8453 10.7333 14.0007 10.6682 14.1156 10.5533C14.2305 10.4384 14.2956 10.283 14.2971 10.1205C14.2985 9.95804 14.236 9.80151 14.1231 9.68465L11.9544 7.51591C11.8382 7.39975 11.6806 7.33449 11.5163 7.33449C11.352 7.33449 11.1944 7.39975 11.0782 7.51591L8.9095 9.68465C8.79333 9.80085 8.72807 9.95843 8.72807 10.1227C8.72807 10.287 8.79333 10.4446 8.9095 10.5608Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_0_2329">
                    <rect
                      width="7.43568"
                      height="7.43567"
                      fill="white"
                      transform="translate(15.2343 14.4602) rotate(-180)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <div className="imgWrp me-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="41"
                height="41"
                viewBox="0 0 41 41"
                fill="none"
              >
                <circle cx="20.2308" cy="20.2554" r="20.2173" fill="#D9D9D9" />
                <path
                  d="M20.3933 13.9376H13.2138C12.8965 13.9377 12.5922 14.0638 12.3679 14.2882C12.1435 14.5125 12.0174 14.8168 12.0173 15.1341V24.7067C12.0174 25.024 12.1435 25.3283 12.3679 25.5527C12.5922 25.7771 12.8965 25.9032 13.2138 25.9033H16.5642C16.4051 25.3591 16.3245 24.795 16.3249 24.2281C16.3249 24.1491 16.3273 24.0677 16.3297 23.9888H14.4104C14.2836 23.9884 14.1621 23.9378 14.0724 23.8482C13.9827 23.7585 13.9322 23.637 13.9318 23.5101C13.9327 23.3835 13.9834 23.2623 14.073 23.1727C14.1625 23.0831 14.2838 23.0324 14.4104 23.0315H16.4446C16.5463 22.5336 16.712 22.051 16.9376 21.5956H14.4104C14.2836 21.5952 14.1621 21.5447 14.0724 21.455C13.9827 21.3653 13.9322 21.2438 13.9318 21.117C13.9327 20.9903 13.9834 20.8691 14.073 20.7796C14.1625 20.69 14.2838 20.6393 14.4104 20.6384H17.5239C17.9488 20.0725 18.4706 19.5863 19.0651 19.2025H14.4104C14.2836 19.2021 14.1621 19.1516 14.0724 19.0619C13.9827 18.9722 13.9322 18.8507 13.9318 18.7238C13.9327 18.5972 13.9834 18.476 14.073 18.3864C14.1625 18.2968 14.2838 18.2461 14.4104 18.2452H19.1967C19.3235 18.2456 19.4451 18.2961 19.5347 18.3858C19.6244 18.4755 19.675 18.597 19.6753 18.7238C19.676 18.7735 19.6679 18.8229 19.6514 18.8698C20.2585 18.5644 20.9147 18.3684 21.5898 18.2907V15.1341C21.5897 14.8168 21.4636 14.5125 21.2392 14.2882C21.0149 14.0638 20.7106 13.9377 20.3933 13.9376ZM19.5341 16.6681C19.4902 16.7131 19.4378 16.7488 19.3798 16.7731C19.3218 16.7973 19.2595 16.8097 19.1967 16.8093H14.4104C14.2836 16.809 14.1621 16.7584 14.0724 16.6687C13.9827 16.5791 13.9322 16.4575 13.9318 16.3307C13.9327 16.204 13.9834 16.0828 14.073 15.9933C14.1625 15.9037 14.2838 15.853 14.4104 15.8521H19.1967C19.3235 15.8524 19.4451 15.903 19.5347 15.9927C19.6244 16.0823 19.675 16.2039 19.6753 16.3307C19.6757 16.3935 19.6633 16.4558 19.6391 16.5138C19.6148 16.5718 19.5791 16.6243 19.5341 16.6681Z"
                  fill="#534F4F"
                />
                <path
                  d="M22.3074 18.7236C21.2188 18.7236 20.1546 19.0464 19.2494 19.6512C18.3442 20.256 17.6388 21.1157 17.2221 22.1214C16.8055 23.1272 16.6965 24.2339 16.9089 25.3016C17.1213 26.3693 17.6455 27.3501 18.4153 28.1199C19.1851 28.8897 20.1659 29.4139 21.2336 29.6263C22.3013 29.8386 23.408 29.7296 24.4138 29.313C25.4195 28.8964 26.2792 28.1909 26.884 27.2858C27.4888 26.3806 27.8116 25.3164 27.8116 24.2278C27.8098 22.7685 27.2293 21.3696 26.1974 20.3377C25.1656 19.3059 23.7666 18.7254 22.3074 18.7236ZM25.014 22.8733L23.6619 24.2278L25.014 25.5823C25.1925 25.7618 25.2925 26.0047 25.2921 26.2578C25.2918 26.5109 25.191 26.7535 25.0121 26.9325C24.8331 27.1115 24.5905 27.2122 24.3374 27.2125C24.0843 27.2129 23.8414 27.1129 23.6619 26.9344L22.3074 25.5823L20.9529 26.9344C20.7734 27.1129 20.5305 27.2129 20.2774 27.2125C20.0243 27.2122 19.7817 27.1115 19.6027 26.9325C19.4237 26.7535 19.323 26.5109 19.3227 26.2578C19.3223 26.0047 19.4223 25.7618 19.6007 25.5823L20.9529 24.2278L19.6007 22.8733C19.4214 22.694 19.3207 22.4508 19.3207 22.1972C19.3207 21.9436 19.4214 21.7005 19.6007 21.5212C19.78 21.3419 20.0232 21.2411 20.2768 21.2411C20.5304 21.2411 20.7736 21.3419 20.9529 21.5212L22.3074 22.8733L23.6619 21.5212C23.7507 21.4324 23.8561 21.3619 23.9721 21.3139C24.0881 21.2659 24.2124 21.2411 24.338 21.2411C24.4635 21.2411 24.5879 21.2659 24.7039 21.3139C24.8199 21.3619 24.9253 21.4324 25.014 21.5212C25.1028 21.6099 25.1732 21.7153 25.2213 21.8313C25.2693 21.9473 25.2941 22.0717 25.2941 22.1972C25.2941 22.3228 25.2693 22.4471 25.2213 22.5631C25.1732 22.6791 25.1028 22.7845 25.014 22.8733Z"
                  fill="#534F4F"
                />
              </svg>
            </div>
            <div className="content">
              <h4 className="m-0 fw-bold" style={{ color: "#E97B7B" }}>
                {data?.totalRejectedBookings?.toString() || "-"}
              </h4>
              <p className="m-0 fw-sbold" style={{ fontSize: 10 }}>
                Rejected Booking
              </p>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default EarningFeature;
